<template>
  <div class="employee-rule-setting">
    <div class="rule-container">
      <div class="rule-left">
        <p class="title">爆款订单复杂度</p>
        <div class="table">
          <el-table :data="hotTable" style="width: 100%">
            <el-table-column prop="type" label="订单类型" width="160"></el-table-column>
            <el-table-column label="区间(左开右闭)">
              <template slot-scope="scope">
                <div class="section">
                  <el-input disabled v-model="scope.row.start" class="gray"></el-input>
                  <p class="connect">--</p>
                  <el-input disabled v-model="scope.row.end" class="gray"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="complexity" label="难度系数" width="160">
              <template slot-scope="scope">
                <el-input class="gray" disabled v-model="scope.row.complexity"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-button class="btn-blue">新增</el-button> -->
      </div>
      <div class="rule-right">
        <p class="title">零拣订单复杂度</p>
        <div class="table">
          <el-table :data="singleTable" style="width: 100%">
            <el-table-column prop="type" label="订单类型" width="160"></el-table-column>
            <el-table-column label="区间(左开右闭)">
              <template slot-scope="scope">
                <div class="section">
                  <el-input disabled v-model="scope.row.start" class="gray"></el-input>
                  <p class="connect">--</p>
                  <el-input disabled v-model="scope.row.end" class="gray"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="complexity" label="难度系数" width="160">
              <template slot-scope="scope">
                <el-input class="gray" disabled v-model="scope.row.complexity"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-button class="btn-blue">新增</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import Employee from "models/employee";
const employee = new Employee();
export default {
  data() {
    return {
      hotTable: [],
      singleTable: []
    };
  },
  activated() {
    this.getAllData();
  },
  created() {},
  methods: {
    getAllData() {
      let id = this.$route.query.id;
      employee.getPickTypeList(id).then(res => {
        if (res.success) {
          let hotTable = [];
          let singleTable = [];
          res.result.hot.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.type = value.type === 1 ? "爆款" : "零拣";
            obj.start = value.start;
            obj.end = value.end;
            obj.complexity = value.complexity;
            hotTable.push(obj);
          });
          res.result.single.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.type = value.type === 1 ? "爆款" : "零拣";
            obj.start = value.start;
            obj.end = value.end;

            if (value.complexity < 0) {
              if (Math.abs(value.complexity) === 1) {
                obj.complexity = "n";
              } else {
                obj.complexity = Math.abs(value.complexity) + "n";
              }
            } else {
              obj.complexity = value.complexity;
            }
            singleTable.push(obj);
          });
          this.hotTable = hotTable;
          this.singleTable = singleTable;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.employee-rule-setting {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .rule-container {
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .rule-left {
      flex: 1;
      margin-right: 10px;
      display: flex;
      height: 100%;
      flex-direction: column;
    }
    .rule-right {
      flex: 1;
      margin-left: 10px;
    }
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 16px;
    }
    .table {
      .section {
        display: flex;
        align-items: center;
        height: 24px;
        .connect {
          height: 18px;
          padding: 0 10px;
          line-height: 24px;
        }
      }
      /deep/.el-input {
        height: 24px;
        width: 64px;
        .el-input__inner {
          height: 24px;
          width: 64px;
          padding: 0 5px;
        }
      }
    }
    .el-button {
      margin-top: 16px;
      width: 72px;
    }
  }
}
</style>
